import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Sidebar from '../../components/sidebar/Sidebar';
import InfoBox from '../../components/InfoBox';
import LoadingFullscreen from '../../components/LoadingFullscreen';
import DetailForm from '../../components/wali-kelas/DetailForm';
import {
    detailWaliKelas,
    updateWaliKelas,
    showFormErrorWaliKelas,
    updateStateWaliKelas,
    resetFormWaliKelas,
    listTeachersWaliKelas,
    listKelasWaliKelas,
    setSelectedTeacher,
    setSelectedKelas,
} from '../../features/waliKelasSlice';
import arrowLeft from '../../assets/icons/arrow-left.svg';
import '../../styles/css/Karyawan.css';

function DetailWaliKelas() {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {
        selectedTeacher,
        selectedKelas,
        listTeachers,
        listKelas,
        loadingEdit,
        isFormEditted,
        statusResApi,
        messageResApi,
        isDisplayMessage,
    } = useSelector((state) => state.waliKelas);

    const [showAlertBack, setShowAlertBack] = useState(false);
    const [showAlertUpdate, setShowAlertUpdate] = useState(false);

    useEffect(() => {
        dispatch(resetFormWaliKelas());
        // fetch detail + lists in parallel
        dispatch(detailWaliKelas(id));
        dispatch(listTeachersWaliKelas());
        dispatch(listKelasWaliKelas());
    }, [id, dispatch]);

    // Once detail + lists are both loaded, resolve the null IDs by matching name/category
    useEffect(() => {
        if (!selectedTeacher || !selectedKelas) return;
        if (!listTeachers.length || !listKelas.length) return;

        // Resolve teacher ID if still null
        if (selectedTeacher.id === null && selectedTeacher.nama) {
            const match = listTeachers.find(
                (t) => t.nama.trim().toLowerCase() === selectedTeacher.nama.trim().toLowerCase()
            );
            if (match) {
                dispatch(setSelectedTeacher({ id: match.id, nama: match.nama }));
            }
        }

        // Resolve kelas ID if still null
        if (selectedKelas.id === null && selectedKelas.category) {
            const match = listKelas.find(
                (k) => k.category.trim().toLowerCase() === selectedKelas.category.trim().toLowerCase()
            );
            if (match) {
                dispatch(setSelectedKelas({ id: match.id, category: match.category }));
            }
        }
    }, [selectedTeacher, selectedKelas, listTeachers, listKelas]);

    function handleBack() {
        if (isFormEditted) {
            setShowAlertBack(true);
        } else {
            navigate(-1);
        }
    }

    function handleSubmit(e) {
        e.preventDefault();
        dispatch(showFormErrorWaliKelas());
        const isValid = selectedTeacher?.id && selectedKelas?.id;
        if (!isValid) return;
        setShowAlertUpdate(true);
    }

    function handleApiUpdate() {
        dispatch(updateWaliKelas({
            id,
            user_id: selectedTeacher.id,
            class_id: selectedKelas.id,
        })).then((res) => {
            if (res.meta.requestStatus === 'fulfilled') {
                navigate(-1);
            }
        });
    }

    return (
        <div className='wrapper-karyawan'>
            <Sidebar />
            <div className='detail-karyawan'>
                <div className='navigation'>
                    <div>
                        <img src={arrowLeft} alt="" onClick={handleBack} />
                        <h1>Detail Wali Kelas</h1>
                    </div>
                    <input
                        type='button'
                        value='Konfirmasi'
                        className='btn-submit'
                        onClick={handleSubmit}
                    />
                </div>
                <div className='detail-form'>
                    <DetailForm />
                </div>
                <LoadingFullscreen loading={loadingEdit} />
            </div>

            {showAlertBack && (
                <div className='bg-modal'>
                    <div className='alert-modal'>
                        <h1>Edit Wali Kelas</h1>
                        <p>Ada perubahan yang belum Anda simpan, Anda yakin ingin membatalkan?</p>
                        <div>
                            <button onClick={() => setShowAlertBack(false)}>Tidak</button>
                            <button onClick={() => navigate(-1)}>Iya</button>
                        </div>
                    </div>
                </div>
            )}

            {showAlertUpdate && (
                <div className='bg-modal'>
                    <div className='alert-modal'>
                        <h1>Edit Wali Kelas</h1>
                        <p>Kamu yakin ingin mengubah wali kelas ini?</p>
                        <div>
                            <button onClick={() => setShowAlertUpdate(false)}>Tidak</button>
                            <button onClick={handleApiUpdate}>Iya</button>
                        </div>
                    </div>
                </div>
            )}

            <InfoBox
                message={messageResApi}
                status={statusResApi}
                isDisplay={isDisplayMessage}
                setIsDisplay={updateStateWaliKelas}
                stateName='isDisplayMessage'
            />
        </div>
    );
}

export default DetailWaliKelas;
